export const createPassword = (id, values) => (dispatch, getState, { api }) => {
  return api.post(`/authenticate/createPassword/${id}`, values)
}